import React from 'react'
import TweetLayout from '../components/TweetLayout'
import resume from '../resume.json'

const imgArr = [
  {id: 0, url: require('../images/portfolio/tip-split-desktop.png')},
  {id: 1, url: require('../images/portfolio/dad-jokes-desktop.png')},
  {id: 2, url: require('../images/portfolio/carousel-of-coders.png')},
  {id: 3, url: require('../images/portfolio/stormy-music-desktop.png')},
  {id: 4, url: require('../images/portfolio/city-explorer-desktop.png')},
  {id: 5, url: require('../images/portfolio/k_space_homepage_storm.png')},
  {id: 6, url: require('../images/portfolio/vibe_social_profile.png')},
  {id: 7, url: require('../images/portfolio/bmh_matters.png')}
]

export default function projects() {
  return (
    <>
      {imgArr.slice(0).reverse().map(obj => (
        <TweetLayout key={obj.id} resume={resume.projects[obj.id]} pic={obj.url} />
      ))}
    </>
  )
}